import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import {
  getEffectivePermissions,
  getStoredUser,
  hasPermission as userHasPermission,
} from '../utils/permissions';

const AuthContext = createContext({
  user: null,
  permissions: {},
  setAuthenticatedUser: () => {},
  logout: () => {},
  hasPermission: () => false,
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => getStoredUser());

  const setAuthenticatedUser = useCallback((nextUser, token) => {
    if (nextUser) {
      localStorage.setItem('user', JSON.stringify(nextUser));
      setUser(nextUser);
    }

    if (token) {
      localStorage.setItem('token', token);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
  }, []);

  const hasPermission = useCallback(
    (permissionName) => userHasPermission(permissionName, user),
    [user]
  );

  const value = useMemo(
    () => ({
      user,
      permissions: getEffectivePermissions(user),
      setAuthenticatedUser,
      logout,
      hasPermission,
    }),
    [hasPermission, logout, setAuthenticatedUser, user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
